export default __webpack_public_path__ + "e6de8bc55cc6aace0896f477ad690893.png";